import { render } from "./TechStack.vue?vue&type=template&id=9cd19766&scoped=true"
import script from "./TechStack.vue?vue&type=script&lang=js"
export * from "./TechStack.vue?vue&type=script&lang=js"

import "./TechStack.vue?vue&type=style&index=0&id=9cd19766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd19766"]])

export default __exports__